import {
	SettingsConfig,
	FormStatus,
	FormTemplate,
	SettingsConfigType,
} from "../../../index";

const reportBugForm = new FormTemplate({
	id: "report_bug",
	name: "Report Bug",
	status: FormStatus.ACTIVE,
	settingsConfig: [
		new SettingsConfig({
			id: "user",
			label: "Contact information",
			type: SettingsConfigType.CURRENT_USER,
			required: true,
		}),
		new SettingsConfig({
			id: "related_add_ons",
			label: "Related Add-On",
			type: SettingsConfigType.STRING,
			required: true,
		}),
		new SettingsConfig({
			id: "description",
			label: "Description",
			type: SettingsConfigType.STRING,
			required: true,
			data: {
				multiline: true,
			},
		}),
	],
});

export { reportBugForm };
